import type { RouteRecordRaw } from 'vue-router'
import { ticketsSettingsRoute } from '@/routes/user/tickets/ticketsSettings'
import { ticketsRootRoute } from '@/routes/user/tickets/ticketsRoot'

export const getTicketsRoutes = (): RouteRecordRaw[] => [ticketsRootRoute, ticketsSettingsRoute]
